<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                '开料单编号/开料单名称/订单编号/客户订单编号 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="chooseOrderDialogVisible = true"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="135px"
        size="small"
        label-position="right"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="'有效状态'">
              <el-checkbox-group v-model="form.techCuttingStatusList">
                <el-checkbox label="N">{{
                  $l('INDEX.order_status_N') || '新增'
                }}</el-checkbox>
                <el-checkbox label="S">{{
                  $l('INDEX.order_status_Y') || '已审核'
                }}</el-checkbox>
                <el-checkbox label="D">{{
                  $l('INDEX.order_status_D') || '已删除'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="'开料单编号'">
              <el-input
                v-model.trim="form.techCuttingNo"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'开料单名称'">
              <el-input
                v-model.trim="form.techCuttingName"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="'订单编号'">
              <el-input v-model.trim="form.orderNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'客户订单编号'">
              <el-input v-model.trim="form.custOrderNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="'产品线'">
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.productLine"
                :body="productLineParams"
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="'审核时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.reviewTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="reviewTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.reviewTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="reviewTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="createTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="createTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>

    <choose-order-dialog
      :visible.sync="chooseOrderDialogVisible"
      :title="'选择订单'"
      type="radio"
      @confirm="onChooseOrderConfirm"
    />
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  techCuttingStatusList: ['N', 'S'],
}
import ChooseOrderDialog from '@/views/factory/components/choose-order'
export default {
  components: { ChooseOrderDialog },

  data() {
    return {
      orderTypeParams: { dictType: 'orderType' },
      productLineParams: { dictType: 'productLine' },
      chooseOrderDialogVisible: false,

      advqueryDialogVisible: false,
      form: { ...initForm },
      formData: { orderCode: '', custOrderNo: '' },

      //提交日期限制
      submitTimeStartPicker: this.submitTimeEnd(),
      submitTimeEndPicker: this.submitTimeStart(),
      //审核日期限制
      reviewTimeStartPicker: this.reviewTimeEnd(),
      reviewTimeEndPicker: this.reviewTimeStart(),
      //创建日期限制
      createTimeStartPicker: this.createTimeEnd(),
      createTimeEndPicker: this.createTimeStart(),

      //修改日期限制
      modifyTimeStartPicker: this.modifyTimeEnd(),
      modifyTimeEndPicker: this.modifyTimeStart(),
    }
  },

  activated() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },

    onChooseOrderConfirm(params) {
      this.formData.orderCode = params.orderCode
      this.formData.custOrderNo = params.custOrderNo
      this.save()
    },

    async save() {
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .techCuttingInfoAddOrderApi({ orderCode: this.formData.orderCode })
        .then((res) => {
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          loadingInstance.close()

          this.$router.replace({
            name: 'technology-techGoodsCutting-detail',
            params: { code: res.body, pageType: 'edit' },
          })
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
        })
        .catch(() => {
          loadingInstance.close()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    // 修改时间限制
    modifyTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.modifyTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    modifyTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.modifyTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 提交时间限制
    submitTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.submitTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.submitTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    submitTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.submitTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.submitTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    //审核日期限制
    reviewTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.reviewTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.reviewTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    reviewTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.reviewTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.reviewTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 创建日期限制
    createTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.createTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    createTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.createTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
